const article = {
    en: {
        articles: {
            article_id: 'Article Id | Article Ids',
            count: 'No Article | 1 Article | {count} Articles',
            comment: 'Comment | Comments',
            additional_info: 'Additional Info',
            total_record: 'Total: 1 article | Total: {total} articles',
            generic_record: 'Total: 1 record | Total: {total} records',
            total_record_more_than: 'Total: More than {max}',
            action_to_all_articles: 'All filtered articles ({total})',
            destroy_confirmation: "You're about to delete the article. Associated files and codings will also be deleted. Are you sure?",
            bulk_destroy_confirmation: "You're about to delete the selected articles. Associated files and codings will also be deleted. Are you sure?",
            unrelease_confirmation: "You're about to unrelese the article. Are you sure?",
            previous: 'Previous',
            next: 'Next',
            row: "Page {page}",
            uploaded: "Uploaded {date}",
            hide_show_columns: "Hide/show columns",
            export: {
                label: {
                    id: 'Id',
                    headline: 'Headline',
                    coding_id: 'Coding Id',
                    assigned_to: 'Assigned to',
                    media_subtype: 'Media Type',
                    country: 'Country',
                    language: 'Language',
                    comments: 'Comments',
                    created_at: 'Created At',
                    published_at: 'Published At',
                    due_date: 'Due Date',
                    status: 'Status',
                    outlet_id: 'Outlet Id',
                    outlet_name: 'Outlet Name',
                    outlet_tier: 'Outlet Tier',
                    insight_url: 'Insight URL',
                    original_url: 'Original URL',
                    authors: 'Authors',
                    authors_handle: 'Authors / Handle',
                    gender: 'Gender',
                    sentiment: 'Sentiment',
                    handle_location: 'Handle Location',
                    followers: 'Followers',
                    likes: 'Likes',
                    no_comments: 'No. Comments',
                    shares: 'Shares',
                    views: 'Views',
                    reactions: 'Reactions',
                    relevancy_score: 'Relevancy Score',
                    relevancy_level: 'Relevancy Level'
                },
                articles_exporting: 'Exporting Articles'
            },
            priority: {
                low: "Low Priority",
                medium: "Medium Priority",
                high: "High Priority",
            },
            coverage: {
                client: "Client Coverage",
                industry: "Industry Coverage",
                press_release: "Press Release",
                do_not_summarize: "Do not Summarize Coverage"
            },
            published: "Published {date}",
						no_summary: "No Summary",
						labels: {
							country: {
								title: "Country"
							},
							outlet: {
								title: "Outlet"
							},
							date_publish: {
								title: "Date Publish"
							},
							language: {
								title: "Language"
							},
							front_page: {
								title: "Front Page"
							},
							url: {
								title: "Url"
							},
							headline: {
								title: "Headline"
							},
							headline_language: {
								title: "Headline Language"
							},
							headline_prompt: {
								title: "Headline Prompt"
							},
							headline_prompt_text: {
								title: "Headline Prompt Text"
							},
							keywords: {
								title: "Keywords"
							},
							content: {
								title: "Content"
							},
							press_release: {
								title: "Press Release"
							},
							priority: {
								title: "Priority"
							},
							authors: {
								title: "Authors"
							},
                            should_sync_with_samsara: {
                                title: "Upload to Insight"
                            },
						},
            form: {
                error: {
                    missing_tags: 'Missing tag: | Missing Tags:',
                    missing_categories: `
                        This article is currently missing tags from the following mandatory category: |
                        This article is currently missing tags from the following mandatory categories:
                    `
                },
                keywords: {
                    field_title: "Enter keywords"
                },
                assets: {
                    delete: "Delete",
                    page_number_label: "Page number(s)",
                    position_label: "Position",
                    choose_files: "Choose Files (or drop here)",
                    upload_files: "Upload Files",
                    at_least_one: 'You Need to attach an asset to be able to delete this one'
                },
                translations: {
                    add: "Add a translation",
                    delete: "Delete translation",
                    delete_confirmation: "You're about to delete the translation. Are you sure? Save the article to save this change."
                },
                outlet: {
                    outlet: "Outlet",
                    find_outlet_placeholder: "Find an outlet",
                    published_date_label: "Date Published",
                    countries_prompt: "All Countries",
                    filter: "Filter by outlet"
                },
                search: "Search",
                coder: {
                    filter: "Filter by coder",
                    change: "Change assignee",
                    select: "Select coder"
                },
                media_type: {
                    filter: "Filter by media type"
                },
                filter_date: {
                    title: 'Date',
                },
                filter_group: {
                    title: 'Group'
								},
                create: {
									title: "New Article",
									save: "Save Article",
									success_message: "New article saved."
								},
                files: {
                  title: 'Upload Image'
                },
                edit_articles: {
                    headers: {
                        title: "Edit selected articles",
                        text: "All selected articles will be updated once you submit.",
                        add_mentions: "Add Mentions",
                        remove_mentions: "Remove Mentions",
                        remove_organization: "Delete Organization",
                        duplicate_mentions: "Duplicate mentions",
                        shared_mentions: "Shared mentions"
                    },
                    labels: {
                        parent_tag: "Parent Tag",
                        coder: "Coder",
                        status: "Status",
                        due_date: "Due date",
                        organizations: "Organizations",
                        category: "Category",
                        tag: "Tag",
                        base_article: "Base article"
                    },
                    actions: {
                        add_mentions: "Add Mentions",
                        remove_mentions: "Remove Mentions",
                        duplicate_mentions: "Duplicate Mentions",
                        remove_organization: "Delete Organization"
                    },
                    modals: {
                      delete_title: "Confirm Delete",
                      organization_delete_message: "Are you sure you want to delete {organization}? This will delete the organization and all its tags on {total} articles. This action is permanent and cannot be undone."
                    }
                }
            },
            mentions: {
                labels: {
                    organizations: "Organizations",
                    tags: "Tags",
                    sources: "Sources"
                }
            },
            tabs_selectors: {
                projects: "Projects",
                metadata: "Metadata",
                full_text: "Full Text",
                translations: "Translations",
                media_eye: "Media Eye",
                executive_report: "ER"
            },
            tabs: {
                assets: {
                    add_asset_btn: "Add an Asset",
                    page_number_label: "Page number(s)",
                    position_label: "Position",
                    choose_files: "Choose Files (or drop here)"
                }
            },
            re_evaluate_keywords: {
                success: "Keywords were re-evaluated",
                fail: "Keywords re-evaluation failed"
            },
            country: "Country",
            user_country: "Social Profile Location",
            created_by: "Created By",
            missing_translations: "Missing translations",
            page: "Pages",
            base_form: {
                recent_outlets: "Recent outlets",
                files: "Files",
                add_asset: "Add a asset"
            },
            key_values: "Key Values",
            add_key_value: "Add Key Values",
            id: "Article ID",
            created_at: "Created At",
            published_at: "Published At",
            due_date: "Due Date",
            outlet: "Outlet",
            outlet_tier: "Outlet Tier",
            authors: "Authors",
            authors_handle: "Authors / Handle",
            media_type: "Media Type",
            headline: "Headline",
            translated_headline: "Translated Headline",
            assigned_to: "Assigned To",
            status: "Status",
            keywords: "Keywords",
            ai_models: 'AI Prompt',
            ai_model_tooltip: 'AI prompt will only be applied if the Coder is set to "Auto-Coder" and Status is "Assigned"',
            keyword: {
                search: "Search...",
                and: "AND",
                or: "OR",
                not: "NOT"
            },
            media_types: {
                magazine: "Magazine",
                radio: "Radio",
                website: "Website",
                newspaper: "Newspaper",
                social_networks: "Social Networks",
                tv: "TV",
                podcast: "Podcast",
                news:	"News",
                blog: "Blog",
                forum: "Forum"
            },
            date: "Date",
            coder: "Coder",
            byline: "Byline",
            language: "Language",
            fav: "Fav",
            custom_score: "Custom Score",
            iq: "IQ",
            impressions: "Impressions",
            circulation: "Circulation",
            ave: "AVE",
            categories: "Categories",
            sources: "Sources",
            quotes: "Quotes",
            summary: "Summary",
            url: "URL",
            gender: "Gender",
            sentiment: "Sentiment",
            handle_location: "Handle Location",
            followers: "Followers",
            likes: "Likes",
            no_comments: "No. Comments",
            shares: "Shares",
            views: "Views",
            reactions: "Reactions",
            link_karma: "Link Karma",
            comment_karma: "Comment Karma",
            statuses: {
                coded: "Coded",
                published_qc: "Published (QC)",
                published_not_qc: "Published (NOT QC)"
            },
            social_posts: {
                providers: {
                    fb: 'Facebook',
                    fb_mention: 'Facebook Mention',
                    fb_public_page: 'Facebook Public Page',
                    gnip: 'X (formerly Twitter)',
                    ig: 'Instagram',
                    ig_mention: 'Instagram Mention',
                    'social-linkedin': 'LinkedIn',
                    linkedin_mention: 'LinkedIn Mention',
                    reddit_mention: 'Reddit',
                    tiktok: 'TikTok',
                    tiktok_mention: 'TikTok Mention',
                    yt: 'Youtube',
                    yt_mention: 'Youtube Mention'
                },
                types: {
                    added_photos: 'Photo',
                    added_video: 'Video',
                    created_event: 'Event',
                    mobile_status_update: 'Status Update',
                    post: 'Post',
                    shared_story: 'Shared Story',
                    wall_post: 'Wall Post',
                    comment: 'Comment',
                    published_story: 'Published Story',
                    reply: 'Reply',
                    quote_retweets: 'Quote Retweets',
                    retweets: 'Retweets',
                    story: 'Story',
                    video: 'Video',
                    text: 'Text',
                    created_note: 'Created Note',
                    ig: 'Instagram',
                },
                account_types: {
                    verified: 'Verified',
                    unverified: 'Unverified'
                }
            },
            include_unfiltered: "Include unfiltered articles",
            warning: {
                title: "Attention Required",
                messages: {
                    coded_articles_selected: "You are attempting to remove a tag that belongs to a mandatory category. This will change the status of the following coded/published articles back to \"in progress\":",
                    missing_categories: `
                        You are attempting to update articles that are either not coded or 
                        coded but do not have any tags from the following mandatory categories:
                    `,
                },
                after_list: {
                    missing_categories: "Please, add the missing mandatory tags before continuing."
                },
                confirm_proceed: "Would you like to proceed?",
                mentions_add: "Mentions are only added to Articles with a coder assigned.",
                mentions_duplicated: 'Mentions are only duplicated to Articles with a coder assigned.',
                unfiltered_disabled: "Select a date range to activate button."
            },
            insight_url: 'Insight URL',
            view_on_insight: 'View on Insight',
            ai_explanation: 'AI Explanation',
            bulk_actions: {
                export: 'Export',
                remove: 'Remove',
                delete: 'Delete',
                group: 'Group',
                edit: 'Edit',
                open: 'Open',
                aiCode: 'AI Code'
            }
        }
    }
}

module.exports.article = article;